import React from 'react';
import { Container } from '@/components/ui';
import { BulkFileUploader } from '@/components/bulk-file-uploader';
import { withPermissions } from '@/components/withPermissions';
import { PERMISSIONS } from '@/types/permissions';
import { usePermissionAccess } from '@/hooks/usePermissionAccess';

const FileImporter: React.FC = () => {
  const canUpload = usePermissionAccess([PERMISSIONS.FILES_UPLOAD]);

  return (
    <Container
      pt="2"
      pb="2"
      size="expand"
      className="file-importer-page"
      minHeight="100%"
      style={{
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <BulkFileUploader canUpload={canUpload} metaValidationMode="client" />
    </Container>
  );
};

export const FileImporterPage = withPermissions(FileImporter, {
  requiredPermissions: [PERMISSIONS.FILES_ACCESS],
  showRoleSwitcher: true,
});
